/**
 * Bookings & Revenue Trend Chart Component
 * - Displays monthly booking volume and revenue data
 * - Interactive line chart with tooltips
 * - Shows revenue trends over time
 */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export default function BookingsRevenueChart() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Revenue',
        data: [18000, 15000, 17000, 12000, 9000, 7000, 7500, 6000, 6500, 8000, 7000, 59873],
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: '#f3f4f6',
        },
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
  };

  return (
    <div className="w-full border-gray-300 border p-3 sm:p-4 py-4 sm:py-5 rounded-lg">
      <div className="mb-4 sm:mb-5 flex flex-col sm:flex-row sm:items-end justify-between gap-2">
        <div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">
            Bookings & Revenue Trend
          </h3>
          <p className="mt-1 text-xs text-gray-500">Monthly booking volume and revenue growth</p>
          <div className="text-xs text-gray-400">July 2, 2025</div>
        </div>
        <div className="text-left sm:text-right">
          <div className="text-xl sm:text-2xl font-semibold text-blue-600">59,873</div>
        </div>
      </div>

      <div className="h-48 sm:h-56 w-full">
        <Line data={data} options={options} />
      </div>

      {/* Legend */}
      <div className="mt-3 flex items-center justify-center gap-2 text-sm text-gray-600">
        <span className="inline-block h-2 w-2 rounded-full bg-blue-500" />
        Revenue
      </div>
    </div>
  );
}
